import React from "react";

const ExclamationTriangle = ({ className = "madie-icon", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.78532 5.73753V9.61632C8.78532 10.067 8.46965 10.5052 7.9977 10.5052C7.52576 10.5052 7.21008 10.067 7.21008 9.61632L7.21008 5.73753C7.21008 5.28685 7.52576 4.84864 7.9977 4.84864C8.46965 4.84864 8.78532 5.28685 8.78532 5.73753ZM8.96708 11.9865C8.96708 12.5562 8.57003 13.0909 7.9977 13.0909C7.42537 13.0909 7.02832 12.5562 7.02832 11.9865C7.02832 11.4168 7.42537 10.8822 7.9977 10.8822C8.57003 10.8822 8.96708 11.4168 8.96708 11.9865ZM9.8103 1.11919L15.7837 13.0699C16.4566 14.4161 15.478 16 13.9734 16H2.02659C0.522002 16 -0.456584 14.4161 0.216288 13.0699L3.203 7.09456L6.1897 1.11919C6.93559 -0.373059 9.06441 -0.373068 9.8103 1.11919ZM8.42066 1.81424C8.24734 1.46749 7.75267 1.46749 7.57935 1.81424L1.60593 13.765C1.44958 14.0778 1.67697 14.4458 2.02659 14.4458H13.9734C14.323 14.4458 14.5504 14.0778 14.3941 13.765L8.42066 1.81424Z"
      />
    </svg>
  );
};

export default ExclamationTriangle;
